import { authApi } from '@/features/auth/authApi';
import { configSlice } from '@/features/config/configSlice';
import { userSelectedMarketSlice } from '@/features/selectedMarket/selectedMarketSlice';
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { oAuthSlice } from '@/features/oAuth/oAuthSlice';
import { mainEmptySplitApi } from '@/features/main/mainApi';
import { widgetBaseApi } from '@/features/widgetBaseApi/widgetBaseApi';

// Create the root reducer separately so we can extract the RootState type
const rootReducer = combineReducers({
  auth: authApi.reducer,
  config: configSlice.reducer,
  main: mainEmptySplitApi.reducer,
  oAuth: oAuthSlice.reducer,
  userSelectedMarket: userSelectedMarketSlice.reducer,
  widget: widgetBaseApi.reducer
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([authApi.middleware, mainEmptySplitApi.middleware, widgetBaseApi.middleware]),
  devTools: process.env.NODE_ENV !== 'production'
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppStore = ReturnType<typeof configureStore>;
// export type AppDispatch = typeof store.dispatch
export type AppDispatch = AppStore['dispatch'];

export const setupStore = (preloadedState) => {
  return configureStore({
    reducer: rootReducer,
    preloadedState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        immutableCheck: false,
        serializableCheck: false
      }).concat([authApi.middleware, mainEmptySplitApi.middleware, widgetBaseApi.middleware])
  });
};
